module.exports = __webpack_public_path__ + "img/l_h3.3445b0e0.png";